<template>
  <div class="zl_pdf" v-loading="loading">
    <pdf ref="zl_pdf" :src="src" :page="currentPage" @num-pages="numPages=$event" @loaded="loadPdfHandler"></pdf>

    <div class="prevBtn btnbox" v-show="numPages > 0 && !loading " v-if="currentPage > 1">
        <span class="el-icon-arrow-left "></span>
    </div>
    <div class="nextBtn btnbox" v-show="numPages > 0 && !loading " v-if="currentPage < numPages">
         <span class="el-icon-arrow-right "></span>
    </div>

    <div class="leftBtn" v-if="currentPage > 1" @click.stop="prevPage"></div>
    <div class="rightBtn" v-if="currentPage < numPages" @click.stop="nextPage"></div>

    <span v-show="numPages > 0 && !loading " class="showPage">{{currentPage}}/{{numPages}}</span>

  </div>
</template>

<script>

  import pdf from 'vue-pdf'

  export default {
    name: 'zl_pdf',
    props: {
      src: {
        type: String,    //默认值，
        default: ''
      }
    },
    data() {
      return {
        loading: true,    //加载中
        loadingError: false,    //加载失败
        numPages: 0,        //分页
        currentPage: 1, //当前显示页数
      }
    },
    watch: {
      src: {
        deep: true,
        immediate: true,
        handler(val) {
          if (val) {
            this.onPreview(val)
          }
        }
      }
    },
    components: {
      pdf
    },
    mounted(){
      let that = this;
      document.onkeydown = function(){
        var oEvent = window.event;
        if (oEvent.keyCode == 37 || oEvent.keyCode == 38 || oEvent.keyCode == 13) { //37左 //38上 13enter
          if (that.numPages > 0){
            that.prevPage()
          }
        }
        if (oEvent.keyCode == 39 || oEvent.keyCode == 40) {//39右   //40下
          if (that.numPages > 0){
            that.nextPage()
          }
        }
      }
      //监听外部要控制pdf的信号
      window.addEventListener('message',ev=>{
        if (ev.data === 'nextPage'){
          this.nextPage()
        }else if (ev.data === 'prePage'){
          this.prevPage()
        }
      })
    },
    methods: {
      //计算pdf页码总数
      onPreview(url) {
        this.loading = true;
        this.numPages = 0;
        this.currentPage = 1;
        let loadURL = pdf.createLoadingTask(url)
        loadURL.promise.then(pdf => {
          this.numPages = pdf.numPages;
          this.currentPage = 1;
        }).catch(err => {
          this.loadingError = err;
        })
      },

      // 上一页
      prevPage() {
        if (this.currentPage == 1) return
        this.currentPage--
      },

      // 下一页
      nextPage() {
        if (this.currentPage == this.numPages) return
        this.currentPage++
      },

      // 回调
      loadPdfHandler(e) {
        this.loading = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .zl_pdf {
    width: 100%;
    /*height: 100%;*/
    position: relative;

    .btnbox{
        width: 30px;
      height: 30px;
      border-radius: 30px;
      background: #409EFF;
      display: flex;
      align-items: center;
      justify-content:center;
    }

    .leftBtn{
      width: 50%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 100;
      cursor: pointer;
    }
    .rightBtn{
      width: 50%;
      top: 0;
      left: 50%;
      height: 100%;
      z-index: 100;
      cursor: pointer;
    }

    .btnbox, .nextBtn, .leftBtn, .rightBtn, .showPage {
      cursor: pointer;
      position: absolute;
      user-select: none;
      transition: all 1s;
    }

    .prevBtn {
      font-size: 20px;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }

    .nextBtn {
      font-size: 20px;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
    }

    .showPage {
      bottom: 1%;
      right: 1%;
      color: #409EFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/zl_pdf.vue